/**
 *功能名称：审批页面
 *创 建 人：弋强
 *日    期：2022/08/17 15:35:39
 */
import {BaseVue, IBaseApprove, CASign} from "@newview/base-web";
import {Component, Prop, Watch} from "vue-property-decorator";
import {grid, comForm, customModal} from "@newview/ui";
import {ActReFlowApi} from "@newview/basics-v2-api";
import {ModuleDynamicPageApi} from "@newview/dbcenter-api";
import {
    ArchiveApproveApi,
    ArchiveApproveItemApi,
    CountersignRecordSheetApi,
    DataApproveInfoApi
} from "@newview/newviewOA-api";
import headerPanel from "./HeaderPanel.vue";
import approveReturn from "./ApproveReturn.vue";
import approvePass from "./ApprovePass.vue";
import noPage from "./NoPage.vue";
import dynamicPage from "./DynamicPage.vue";
import {UserInforApi} from "@newview/system-api";
// import {CASign} from "@newview/tools";
import {CaSignatureApi} from "@newview/comprehensive-api";

@Component({
    components: {
        headerPanel, approveReturn, approvePass, noPage, dynamicPage
    }
})
export default class ApprovePage extends BaseVue {

    //#region 接口定义区

    private readonly moduleDynamicPageApi: ModuleDynamicPageApi = new ModuleDynamicPageApi();
    private actReFlowApi: ActReFlowApi = new ActReFlowApi();
    private countersignRecordSheetApi: CountersignRecordSheetApi = new CountersignRecordSheetApi();
    userInforApi: UserInforApi = new UserInforApi();
    archiveApproveItemApi: ArchiveApproveItemApi = new ArchiveApproveItemApi();
    archiveApproveApi: ArchiveApproveApi = new ArchiveApproveApi();
    caSignatureApi: CaSignatureApi = new CaSignatureApi();
    dataApproveInfoApi: DataApproveInfoApi = new DataApproveInfoApi();
    // 签字
    caSign: CASign = new CASign();
    //#endregion 接口定义区

    //#region 变量定义区

    @Prop({default: false})
    onlyView?: boolean;
    @Prop({default: true})
    back?: boolean;
    @Prop({default: true})
    flowView?: boolean;

    // 审批数据
    @Prop({default: () => ({})})
    approveData: any;
    actReFlow: any;
    spinLoading: boolean = false;
    currentStep = 1
    // 审批详情页
    approvePages: any[] = [];
    currentPage: any = {path: '', component: ""};
    pageComponent?: IBaseApprove; // 页面组件
    nextNode: any
    steps: any[] = [];
    stepsAll: any = []
    finishSteps: any[] = [];
    taskId = ''
    FlowStep=""
    // 退回、通过    
    showReturn: boolean = false;
    showPass: boolean = false;
    showStep = true
    businessdataForm: any = {}
    businessdataList: any = {}
    businessListForm: any = []
    newStep: any = {}; // 当前节点
    isEndFlag = false
    approveStatus = 0
    result = 0
    AuditIds = ''
    FlowOpinion = '同意'
    flowTime = this.getCurrentDate()
    btnLoading = false;
    subProjectName = this.$globalData_Plms.itemInfo.subProjectName
    //#endregion 变量定义区

    //#region 事件定义区

    async mounted() {

        await this.loadData();
        this.$nextTick(() => {
            setTimeout(() => {
                this.pageComponent = this.getPageComponent();
                this.pageComponent.init(this.approveData, this.actReFlow);
                this.approveStatus = this.approveData.approveStatus
                console.log("mounted", this.pageComponent);
            }, 500);
        });
    }

    businessdata(data) {
        this.businessdataForm = data
        this.businessdataList = data
    }

    businessList(data){
        this.businessListForm = data
    }

    //#endregion 事件定义区

    //#region 方法定义区

    async loadData() {
        this.spinLoading = true;
        this.taskId = this.approveData.Id
        if (this.approveData.FlowCode == 'WithoutApprove') {

            const loadOtherInfo = async () => {
                let apiResult:any = await this.archiveApproveItemApi.getEntitiesDynamic(this.getQueryWrapper().eq("ApprovrId", this.approveData.Id));
                this.steps = this.parseApiResult(apiResult);
                let list = this.Baselinq.from(this.steps).where(item => item.PreNode&&item.PreNode=="_3.5"&&item.StepStatus==1).toArray();
                if (list.length>0){
                    this.steps = this.steps.filter(e=>e.PreNode!="_4.5")
                }
                this.steps = this.Baselinq.from(this.steps).orderBy(item => item.PreNode).toArray();

            }
            if (this.isNull(this.approveData.DetailPageUrl)) {
                this.warning(`${this.actReFlow.FlowName} 未配置详情页面`);
                return;
            } else {
                this.loadApprovePages();
                this.currentPage = this.getPage(this.approveData.DetailPageUrl);
                console.log(this.currentPage,'???')
                this.actReFlow = this.approveData
            }
            this.spinLoading = false;
            await loadOtherInfo();
        } else {
            const loadOtherInfo = async () => {
                // 3. 判断审批是否需要选择人
                let data = await this.flowApi.getNextNodeInfo(this.approveData.Id);
                this.result = data.data
                // 4. 获取流程审批记录
                let apiResult: any= []
                if (this.subProjectName.indexOf('洛卢') != -1 || this.getProjectDataId() == 16||this.getProjectDataId() == 23||this.getRoadId()==51||this.approveData.FlowCode=="QT_WorkerSalaryApproval"){
                    if (this.approveData.FlowCode=="Measurementpaymentnew"||this.approveData.FlowCode=="JLMeasurement"){
                        apiResult = await this.flowApi.getApplyStatusTwo(this.approveData.ActProcessInstanceId);
                    }else {
                        apiResult = await this.flowApi.getApplyStatus(this.approveData.ActProcessInstanceId);
                    }

                }else {
                    apiResult = await this.flowApi.getApplyStatusTwo(this.approveData.ActProcessInstanceId);
                }

                if (this.steps.length==0){
                    this.steps = this.parseApiResult(apiResult);
                    this.stepsAll = this.parseApiResult(apiResult);
                }

                // if (this.approveData.FlowCode == "ArchiveMeetingApply") {
                //     this.steps = this.steps.filter(e => e.PreNode != "_6")
                // }

                // this.steps = this.Baselinq.from(this.steps).orderBy(item => item.ApproveTime).toArray();
                for (const element of this.steps) {
                    if (!this.isNull(element.AuditIds)) {
                        let res: any = await this.userInforApi.getUserByUserId(element.AuditIds)
                        if (res.code == 200 && res.data) {
                            res.data.forEach(data => {
                                this.AuditIds += data.userTrueName + ",";
                            });
                            this.AuditIds = this.AuditIds.substring(this.AuditIds.length - 1, 0);
                        }
                    }
                }
                //相同节点去重
                // this.steps = this.duplicateRemovalKey(this.steps,"PreNode")
                // this.steps = this.steps.filter(e=>e.AuditType!=undefined||e.PreNode=="_1"||e.AuditIds==this.getUserId())
                // //如果节点没有审批时间、意见、默认该节点审批人是当前登录人
                // for (let i = 0; i < this.steps.length; i++) {
                //     if (i ==this.steps.length&&this.steps[i].AuditType!=1){
                //         this.steps[i].AuditType
                //     }
                // }
                // debugger


                // 5. 获取能退回的节点
                let res: any = await this.flowApi.getReturnNodes(this.approveData.ActProcessInstanceId);
                if (res.length > 0) {
                    for (const element of res) {
                        // 过滤会签节点
                        if (this.isNull(element.isLoop)) {
                            this.finishSteps.push(element)
                        }
                    }

                }
                // this.finishSteps = (await this.flowApi.getReturnNodes(this.approveData.ActProcessInstanceId)) as any;
                console.log("steps", this.steps, this.finishSteps);
                this.spinLoading = false;
            }
            // 1. 获取流程信息
            this.actReFlow = await this.getActReFlow(this.approveData.FlowCode);
            if (this.isNull(this.actReFlow)) {
                this.warning(`未获取到流程信息`);
                this.currentPage = {path: 'noPage', component: "noPage"};
                loadOtherInfo();
                return;
            }

            // 2. 获取审批页面 
            if (this.isNull(this.actReFlow.DetailPageUrl)) {
                // 3. 判断是否存在动态页面
                let apiResult = await this.moduleDynamicPageApi.isExist(this.getQueryWrapper().eq("ModuleId", this.actReFlow.Id).eq("Language", 2).eq("PageType", 2));
                const data = this.parseApiResult(apiResult);
                if (data) { // 存在页面
                    this.currentPage = {path: 'dynamicPage', component: "dynamicPage"}
                } else {
                    this.warning(`${this.actReFlow.FlowName} 未配置详情页面`);
                    this.currentPage = {path: 'noPage', component: "noPage"};
                    loadOtherInfo();
                    return;
                }
            } else {
                this.loadApprovePages();
                this.currentPage = this.getPage(this.actReFlow.DetailPageUrl);
                console.log("path", this.isNull(this.currentPage) ? "" : this.currentPage.path);
            }
            await loadOtherInfo();
        }

        let hq: any = this.Baselinq.from(this.steps).where((item) => item["StepStatus"] == "1").toArray();
        this.FlowStep = hq.length>0? hq[0].PreNode : 0;
        try {

            // this.steps.forEach((element,index) => {
            //     if(element.StepStatus=="1"){
            //         this.currentStep = index
            //         throw new Error('LoopInterrupt');         //满足条件，跳出循环
            //     }
            //
            // });
        } catch (e:any) {
            if (e.message !== "LoopInterrupt") throw e
        }
    }

    /**
     * 加载审批页面集合
     */
    loadApprovePages() {
        let pages = this.getWindow().approvePages;
        this.approvePages = this.isNull(pages) ? [] : pages;
    }

    /**
     * 获取当前审批页
     * @param path
     * @returns
     */
    getPage(path) {
        let pages = this.approvePages.filter(item => item.path == path);
        if (pages.length == 0) {
            return {path: '', component: ""}
        }

        return pages[0];
    }

    /**
     * 获取详情页组件
     * @returns
     */
    getPageComponent() {
        return this.ref("pageRef") as IBaseApprove;
    }

    /**
     * 获取流程步骤标题
     * @param item
     * @returns
     */
    getStepTitleStr(item) {
        if (!this.isNull(item.AuditIds)) {
            return item.StepName + ' (' + this.AuditIds + ')'
        } else if (this.isNull(item.ApproveUser)) {
            return item.StepName
        } else {
            return item.StepName + ' (' + item.ApproveUser + ')'
        }
        // return this.isNull(item.ApproveUser) ? item.StepName : this.isNull(this.AuditIds) ? item.StepName + ' (' + this.AuditIds + ')' : item.StepName + ' (' + item.ApproveUser + ')';
    }


    /**
     * 获取流程步骤内容
     * @param item
     * @returns
     */
    getStepContenStr(item) {
        if (item.StepStatus == "1") {
            return '处理中'
        } else if (item.StepStatus == "2") {
            return this.isNull(item.ApproveMsg) ? `时间: ${item.ApproveTime}` : `审批人: ${item.ApproveUser} ；时间: ${item.ApproveTime} ；意见: ${item.ApproveMsg}`
        } else {
            return ''
        }
    }

    /**
     * 获取流程步骤状态文字
     * @param item
     * @returns
     */
    getStepStatusStr(item) {
        const status = {
            "1": 'process',
            "2": 'finish'
        }

        return item.AuditType == 2 ? 'error' : status[item.StepStatus]
    }


    /**
     * 退回流程
     */
    async doReturn() {
        this.btnLoading = true;
        const data = this.ref("approveReturnRef").getData();
        this.approveData.FileStatus = data.step
        if (!this.isNull(this.approveData.BusinessKey)){
            await this.countersignRecordSheetApi.deleteByFilter1(this.approveData.BusinessKey.split("_")[1])
        }
        if (this.actReFlow.FlowCode == "SendingDocumentApply" || this.actReFlow.FlowCode == "ExternalCommunication" || this.actReFlow.FlowCode == "SignPaperApply" || this.actReFlow.FlowCode == "ArchiveMeetingApply") {
            if (this.newStep.PreNode == "_5" || this.newStep.PreNode == "_3" || this.newStep.PreNode == "_6") {
                let res: any = await this.countersignRecordSheetApi.getEntities(this.getQueryWrapper().eq("OutgoingId", this.approveData.BusinessKey.split("_")[1]).eq("FlowCode", this.approveData.FlowCode).eq("PreNode", this.newStep.PreNode).eq("Auditstatus", 2))
                if (res.code == 200) {
                    if (res.data.length > 0) {
                        this.$Message.info("当前会签节点只能一个人选择退回节点！！！")
                        return
                    }
                }
                let newObj: any = {
                    OutgoingId: this.approveData.BusinessKey.split("_")[1],
                    UserId: this.$globalData_Plms.localUser.id,
                    Auditstatus: 2,
                    AuditOption: data.msg,
                    PreNode: this.newStep.PreNode,
                    FlowCode: this.approveData.FlowCode,
                    BackNode: data.step
                }
                await this.countersignRecordSheetApi.save(newObj)
            } else {
                this.approveData.FileStatus = data.step
            }
        }

        //洛卢来文流程特殊处理
        if (this.actReFlow.FlowCode == "WithoutApprove") {
            let apiResult = await this.archiveApproveItemApi.getEntitiesDynamic(this.getQueryWrapper().eq("ApprovrId", this.actReFlow.Id).eq("ApproveUserId", this.$globalData_Plms.localUser.id).eq("StepStatus", 1).eq("PreNode", this.actReFlow.PreNode))
            const result = this.parseApiResult(apiResult);
            await this.archiveApproveItemApi.save({
                Id: result[0].Id,
                StepStatus: 3,
                ApproveMsg: data.msg,
                ApproveTime: new Date()
            })
        }

        if(this.approveData.ActProcessInstanceId){
            let apiResult = await this.flowApi.returnTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, data.step, this.getUserId(), this.getUserTrueName());
            const result = this.parseApiResult(apiResult);
        }
        this.showReturn = false;
        let res: any = await this.flowApi.getNextNodeInfo(this.approveData.Id, data.step)
        if (res.data) {
            this.sendWeChartMsgToAppoint(res.data, this.steps[0].ApproveUser,this.approveData.Title, this.approveData.Title)
            this.sendWeComMsgToAppoint(res.data, this.steps[0].ApproveUser,this.approveData.Title, this.approveData.Title)
        }
        this.success('退回成功');
        var queryWrapper = this.getQueryWrapper();

        queryWrapper.eq("CACode", this.approveData.BusinessKey)
        if (this.approveData.FileStatus != "_1"){
            var number = Number( this.approveData.FileStatus.substring(1));
            let s :any= []
            for (let i = number; i <= 20; i++) {
                let aa = "_"+i
                s.push(aa)
            }
            queryWrapper.in("FlowStep",s)
        }
        await this.caSignatureApi.deleteByFilter(queryWrapper)
        // await this.caSignatureApi;
        // await this.dataApproveInfoApi.deleteByFilter(this.getQueryWrapper().eq("CACode", this.approveData.BusinessKey).ge("PreNode", data.step))
        if (this.pageComponent) {
            this.pageComponent!.closeModal();
            this.pageComponent!.return(this.finishSteps.length == 1 ? true : data.method == 'start', this.approveData, data);
        }
        this.$nextTick(() => {
            this.$emit('returnTask');
        })
        this.btnLoading = false;
    }

    /**
     * 打开弹框
     */
    async doShowPass() {


        //判断是否是发文流程
        if (this.actReFlow.FlowCode == "SendingDocumentApply") {
            //判断当前所处流程步骤
            let newStep = this.stepsAll[this.stepsAll.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2" || newStep.PreNode == "_4") {
                if (this.isNull(this.businessdataForm.nextStep)) {
                    this.alert("请选择下一流程步骤！");
                    return
                }
                if (this.businessdataForm.nextStep == "_3") { // 部门会稿 需要多人会签 必须选人
                    if (this.isNull(this.businessdataForm.nextUserIds)) {
                        this.alert("请选择下一步流程处理人！");
                        return
                    }
                }

            }
        }
        if (this.actReFlow.FlowCode == "ZDWArchiveMeetingApply") {
            //判断当前所处流程步骤
            let newStep = this.stepsAll[this.stepsAll.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2") {
                if (this.isNull(this.businessdataForm.nextStep)) {
                    this.alert("请选择下一流程步骤！");
                    return
                }
                if (this.businessdataForm.nextStep == "_3") { // 部门会稿 需要多人会签 必须选人
                    if (this.isNull(this.businessdataForm.nextUserIds)) {
                        this.alert("请选择下一步流程处理人！");
                        return
                    }
                }

            }
        }
        if (this.actReFlow.FlowCode == "WritingPartyApply") {
            //判断当前所处流程步骤
            let newStep = this.stepsAll[this.stepsAll.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2" || newStep.PreNode == "_4") {
                if (this.isNull(this.businessdataForm.nextStep)) {
                    this.alert("请选择下一流程步骤！");
                    return
                }
                if (this.businessdataForm.nextStep == "_3" || this.businessdataForm.nextStep == "_5") { // 部门会稿 需要多人会签 必须选人
                    if (this.isNull(this.businessdataForm.nextUserIds)) {
                        this.alert("请选择下一步流程处理人！");
                        return
                    }
                }

            }
        }
        if (this.actReFlow.FlowCode == "ExternalCommunication") {
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2" || newStep.PreNode == "_4") {
                if (this.isNull(this.businessdataForm.nextUserIds)) {
                    this.alert("请选择下一步流程处理人！");
                    return
                }
            }
        }
        if (this.actReFlow.FlowCode == "SealApply") {
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2") {
                if (this.isNull(this.businessdataForm.nextUserIds)) {
                    this.alert("请选择下一步流程处理人！");
                    return
                }
            }
        }
        if (this.actReFlow.FlowCode == "ContractManagementApply") {
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2") {
                if (this.isNull(this.businessdataForm.nextStep)) {
                    this.alert("请选择下一流程步骤！");
                    return
                }
                if (this.businessdataForm.nextStep == "_3") {
                    if (this.isNull(this.businessdataForm.nextUserIds)) {
                        this.alert("请选择下一步流程处理人！");
                        return
                    }
                }
            } else if (newStep.PreNode == "_6") {
                if (this.isNull(this.businessdataForm.nextUserIds)) {
                    this.alert("请选择下一步流程处理人！");
                    return
                }
            }
        }
        if (this.actReFlow.FlowCode == "WorkOverApplyLL") {//加班申请
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2") {
                if (this.isNull(this.businessdataForm.nextUserIds)) {
                    this.alert("请选择下一步流程处理人！");
                    return
                }
            }
        }
        if (this.actReFlow.FlowCode == "SignPaperApply") {//签报
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2") {
                if (this.isNull(this.businessdataForm.nextStep)) {
                    this.alert("请选择下一流程步骤！");
                    return
                }
                if (this.businessdataForm.nextStep == "_3" || this.businessdataForm.nextStep == "_5") { // 部门会稿 需要多人会签 必须选人
                    if (this.isNull(this.businessdataForm.nextUserIds)) {
                        this.alert("请选择下一步流程处理人！");
                        return
                    }
                }

            }
        }

        if (this.actReFlow.FlowCode == "ArchiveMeetingApply") {//会议纪要
            let newStep = this.stepsAll[this.stepsAll.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2") {
                if (this.isNull(this.businessdataForm.nextStep)) {
                    this.alert("请选择下一流程步骤！");
                    return
                }
                if (this.businessdataForm.nextStep == "_3" || this.businessdataForm.nextStep == "_5") { // 部门会稿 需要多人会签 必须选人
                    if (this.isNull(this.businessdataForm.nextUserIds)) {
                        this.alert("请选择下一步流程处理人！");
                        return
                    }
                }

            }
        }

        if (this.actReFlow.FlowCode == "DispatchApproval") {//秦唐发文审批
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_3") {
                if (this.isNull(this.businessdataForm.nextUserIds)) {
                    this.alert("请选择会签人员！");
                    return
                }
            }
            if (newStep.PreNode == "_5" || newStep.PreNode == "_8") {
                if (this.isNull(this.businessdataForm.nextStep)) {
                    this.alert("请选择下一流程步骤！");
                    return
                }
            }
        }

        if (this.actReFlow.FlowCode == "StartWorkExamine") {//开工条件核查
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_3") {
                if (!this.steps[1].ApproveUserId){
                    if (this.isNull(this.businessdataForm.nextUserIds)) {
                        this.alert("请选择下一步流程处理人！");
                        return
                    }
                }
            }


        }
        if (this.actReFlow.FlowCode == "DispatchReceiveApproval") {//秦唐收文审批
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            if (newStep.PreNode == "_2" || newStep.PreNode == "_4") {
                if (this.isNull(this.businessdataForm.nextUserIds)) {
                    this.alert("请选择会签人员！");
                    return
                }
            }
        }
        if (this.actReFlow.FlowCode == "ProbationAssessmentApproval" || this.actReFlow.FlowCode == "StaffRegularizationApproval") {
            let newStep = this.steps[this.steps.length - 1]
            if (newStep.PreNode == "_3"){
                if (this.businessListForm.length > 0){
                    for (const argument of this.businessListForm) {
                        if (this.isNull(argument.Score)){
                            this.alert("请先完成考核打分");
                            return
                        }
                    }
                }
            }
        }


        this.showPass = true;
        if (this.pageComponent) {
            this.pageComponent!.openModal();
        }
    }

    doreturn() {
        //判断是否是发文流程
        if (this.actReFlow.FlowCode == "SendingDocumentApply" || this.actReFlow.FlowCode == "SignPaperApply" || this.actReFlow.FlowCode == "ArchiveMeetingApply") {
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
        }
        if (this.actReFlow.FlowCode == "ExternalCommunication") {
            //判断当前所处流程步骤
            let newStep = this.steps[this.steps.length - 1]
            this.newStep = newStep
            //如果是发文流程 则不显示退回步骤
            this.showStep = false
        }
        this.showReturn = true;
        if (this.pageComponent) {
            this.pageComponent!.openModal();
        }
    }

    /**
     * 关闭弹框
     */
    doClosePass() {
        this.showPass = false;
        if (this.pageComponent) {
            this.pageComponent!.closeModal();
        }
    }

    /**
     * 通过流程
     */
    async doPass() {
        debugger
        this.btnLoading = true;
        const data = this.ref("approvePassRef").getData();
        this.FlowOpinion = data.msg
        this.flowTime = data.date

        if (this.approveData.isAudit == '1') {
            const caResult = await this.caSign.DoSeal(1, this.approveData.BusinessKey) as any;
            if (caResult==-1){
                localStorage.removeItem('password')
                this.showPass =false
                this.error("CA密钥错误，请重新输入！")
                return
            }
            if (caResult==-2){ // 该账号还未申请签字证书
                localStorage.removeItem('password')
                this.showPass =false
                return
            }

            await this.saveCaSign(caResult)
        }

        //资金计划填报盖章
        if ((this.actReFlow.FlowCode == "InterimPaymentApproval"
            || this.actReFlow.FlowCode == "QT-DFFinanceReport"
            || this.actReFlow.FlowCode == "QT-AQFinanceReport"
            ||this.actReFlow.FlowCode == "QT-FinanceReport"|| this.actReFlow.FlowCode == "QT_WorkerSalaryApproval") ){
            const caResult =  await  this.caSign.DoSeal(3,  this.approveData.BusinessKey) as any;
            // debugger
            if (caResult == -1){
              localStorage.removeItem("password"+ this.getUserId() );
                this.error("CA密钥错误，请重新输入！")
                return
            }
            if (caResult == -2){
                localStorage.removeItem("password"+ this.getUserId() );
                return
            }
            //流程在第二步时保存
            if(this.FlowStep=="_2"){
                setTimeout(async ()=>{
                    await this.saveCaSign(caResult)
                },1000)
            }
        }

        //石太监理指令第三步的时候盖章
        if (this.actReFlow.FlowCode == "STJLZLXF"){
            const caResult =  await  this.caSign.DoSeal(3,  this.approveData.BusinessKey) as any;
            // debugger
            if (caResult == -1){
                localStorage.removeItem("password"+ this.getUserId() );
                this.error("CA密钥错误，请重新输入！")
                return
            }
            if (caResult == -2){
                localStorage.removeItem("password"+ this.getUserId() );
                return
            }
            //流程在第二步时保存
            if(this.FlowStep=="_3"){
                await this.saveCaSign(caResult)
            }
        }
        //石太监理指令回复第二步的时候盖章
        if (this.actReFlow.FlowCode == "STJLZLHF"||this.actReFlow.FlowCode == "FXSubitemHome"){
            const caResult =  await  this.caSign.DoSeal(3,  this.approveData.BusinessKey) as any;
            // debugger
            if (caResult == -1){
                localStorage.removeItem("password"+ this.getUserId() );
                this.error("CA密钥错误，请重新输入！")
                return
            }
            if (caResult == -2){
                localStorage.removeItem("password"+ this.getUserId() );
                return
            }
            //流程在第二步时保存
            if(this.FlowStep=="_2"||this.FlowStep=="_4"){
                await this.saveCaSign(caResult,2)
            }
        }
        //石太变更模块功能
        if (this.actReFlow.FlowCode == "proposalapplication"||this.actReFlow.FlowCode == "expenseapplication"
            ||this.actReFlow.FlowCode == "OrderApplication"||this.actReFlow.FlowCode == "DesignChange"){
            const caResult =  await  this.caSign.DoSeal(3,  this.approveData.BusinessKey) as any;
            // debugger
            if (caResult == -1){
                localStorage.removeItem("password"+ this.getUserId() );
                this.error("CA密钥错误，请重新输入！")
                return
            }
            if (caResult == -2){
                localStorage.removeItem("password"+ this.getUserId() );
                return
            }
            await this.saveCaSign(caResult,2)
        }

        if((this.getProjectDataId() == 27 || this.getProjectDataId() == 16) && this.actReFlow.FlowCode !== "WithoutApprove"){
            await this.saveApproveInfo()
        }
        // 下一节点是会签，需要调用拾取接口claimTask
        // 审批需要新增表数据；
        //判断是否是最后一人审批， 如果是最后一人，他是退回， 直接走退回接口；
        // 如果他是通过， 查表是否别人有不同意，如果有， 调用退回接口，  auditType = 1；
        //判断是否是发文流程  //特殊处理
        if (this.actReFlow.FlowCode == "SendingDocumentApply" || this.actReFlow.FlowCode == "WritingPartyApply" || this.actReFlow.FlowCode == "ExternalCommunication" || this.actReFlow.FlowCode == "SealApply"|| this.actReFlow.FlowCode == "SealApplyNew" || this.actReFlow.FlowCode == "SignPaperApply"
            || this.actReFlow.FlowCode == "ContractManagementApply" || this.actReFlow.FlowCode == "WorkOverApplyLL" || this.actReFlow.FlowCode == "ReadknowledgeApply" || this.actReFlow.FlowCode == "ArchiveMeetingApply" || this.actReFlow.FlowCode == "ZJLArchiveMeetingApply"|| this.actReFlow.FlowCode == "ZDWArchiveMeetingApply"
            || this.actReFlow.FlowCode == "DispatchApproval" || this.actReFlow.FlowCode == "DispatchReceiveApproval" || this.actReFlow.FlowCode == "QT-NoticeRectification"|| this.actReFlow.FlowCode == "ZDWArchiveMeetingApply"|| this.actReFlow.FlowCode == "DesignChange") {
            if (!this.isNull(this.businessdataForm.nextStep)) {

                if ((this.actReFlow.FlowCode == "SignPaperApply" || this.actReFlow.FlowCode == "ArchiveMeetingApply") && this.businessdataForm.nextStep == "_5") {
                    await this.JumpMultipleNodes()
                    return;
                }
                if (this.actReFlow.FlowCode == "SendingDocumentApply" && (this.businessdataForm.nextStep == "_4" || this.businessdataForm.nextStep == "_6")) {
                    await this.JumpTask()
                    return;
                }
                if (this.actReFlow.FlowCode == "ZDWArchiveMeetingApply" && (this.businessdataForm.nextStep == "_4")) {
                    await this.JumpTask()
                    return;
                }
                if (this.actReFlow.FlowCode == "DispatchApproval" && (this.businessdataForm.nextStep == "_6" || this.businessdataForm.nextStep == "_7")) {
                    await this.JumpTask()
                    return;
                }
                if (this.actReFlow.FlowCode == "WritingPartyApply" ){
                    if (this.businessdataForm.nextStep == "_4" || this.businessdataForm.nextStep == "_6"){
                        await this.JumpTask()
                        return;
                    }
                }
                
                if (this.businessdataForm.nextStep == "_3" || this.businessdataForm.nextStep == "_4" || this.businessdataForm.nextStep == "_5" || this.businessdataForm.nextStep == "_6") { //部门会搞  会签
                    //需要存到新的表里
                    let nextUserIds = this.businessdataForm.nextUserIds
                    let nextUserIdList = []
                    if (!this.isNull(nextUserIds)) {
                        nextUserIdList = nextUserIds.split(",")
                    }
                    let NumberReaders = nextUserIdList.length;
                    let apiResult = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), nextUserIds, {loopNum: NumberReaders});
                    const result = this.parseApiResult(apiResult);

                    // if ( this.approveData.isAudit == '1' ) await this.saveCaSign(this.approveData.BusinessKey)
                    this.showPass = false;
                    this.success('审批通过');
                    if (this.pageComponent) {
                        this.pageComponent!.closeModal();
                        this.pageComponent!.pass(result, this.approveData);
                    }
                    if (nextUserIdList.length >= 1) {
                        //拾取任务
                        await this.flowApi.claimTask(this.approveData.ActProcessInstanceId, nextUserIds)
                        this.sendWeComMsgToAppoint(nextUserIds, this.approveData.Title, this.approveData.Title)
                        this.sendWeChartMsgToAppoint(nextUserIds, "",this.approveData.Title, this.approveData.Title)
                    }
                    this.$nextTick(() => {
                        this.$emit('passTask');
                    })
                    return;

                } else {
                    await this.JumpTask()
                    return;
                }
            } else if (this.approveData.nrOfActiveInstances && this.approveData.nrOfActiveInstances != 1 && (this.newStep.PreNode == "_4" || this.newStep.PreNode == "_2")) { //并且不是会签最后一步
                let newObj: any = {
                    OutgoingId: this.approveData.BusinessKey.split("_")[1],
                    UserId: this.$globalData_Plms.localUser.id,
                    Auditstatus: 1,
                    AuditOption: data.msg,
                    PreNode: this.newStep.PreNode,
                    FlowCode: this.approveData.FlowCode
                }
                await this.countersignRecordSheetApi.save(newObj)
                let apiResult = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), data.nextUserIds);
                const result = this.parseApiResult(apiResult);
                // if ( this.approveData.isAudit == '1'&&this.getProjectDataId() == 23) await this.saveCaSign(this.approveData.BusinessKey)
                this.showPass = false;
                this.success('审批通过');
                if (this.pageComponent) {
                    this.pageComponent!.closeModal();
                    this.pageComponent!.pass(result, this.approveData);
                }
                this.$nextTick(() => {
                    this.$emit('passTask');
                })
                return;
            } else if (this.approveData.nrOfActiveInstances && this.approveData.nrOfActiveInstances != 1 && this.actReFlow.FlowCode != 'ReadknowledgeApply'
            ) {
                let apiResult = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), data.nextUserIds);
                const result = this.parseApiResult(apiResult);

                this.showPass = false;

                let preNodeId = this.newStep.PreNode   //选择跳转的节点id;
                if (this.actReFlow.FlowCode == "SendingDocumentApply" && !this.isNull(preNodeId)) {
                    let FileStatus = parseInt(preNodeId.split("_")[1])
                    if (FileStatus != 6 && FileStatus != 7 && FileStatus != 8 && FileStatus != 9 && FileStatus != 10) {
                        this.approveData.FileStatus = FileStatus
                    }
                }
                // if ( this.approveData.isAudit == '1' &&this.getProjectDataId() == 23) await this.saveCaSign(this.approveData.BusinessKey)
                this.success('审批通过');
                if (this.pageComponent) {
                    this.pageComponent!.closeModal();
                    this.pageComponent!.pass(result, this.approveData);
                }
                this.$nextTick(() => {
                    this.$emit('passTask');
                })
                let newObj: any = {
                    OutgoingId: this.approveData.BusinessKey.split("_")[1],
                    UserId: this.$globalData_Plms.localUser.id,
                    Auditstatus: 1,
                    AuditOption: data.msg,
                    PreNode: this.newStep.PreNode,
                    FlowCode: this.approveData.FlowCode
                }
                await this.countersignRecordSheetApi.save(newObj)
                return;
            }
            if (this.approveData.nrOfActiveInstances && this.approveData.nrOfActiveInstances == 1 && this.actReFlow.FlowCode != "ContractManagementApply"&& this.actReFlow.FlowCode != "DesignChange") { //会签最后一个节点

                let res: any = await this.countersignRecordSheetApi.getEntities(this.getQueryWrapper().eq("OutgoingId", this.approveData.BusinessKey.split("_")[1]).eq("FlowCode", this.approveData.FlowCode))
                await this.countersignRecordSheetApi.deleteByFilter1(this.approveData.BusinessKey.split("_")[1])
                if (res.code == 200) {
                    let backlist: any = res.data.filter(e => e.Auditstatus == 2)
                    if (backlist.length > 0) {
                        var number = Number( this.approveData.FileStatus.substring(1));
                        var queryWrapper = this.getQueryWrapper();
                        queryWrapper.eq("CACode", this.approveData.BusinessKey)
                        let s :any= []
                        for (let i = number; i <= 20; i++) {
                            let aa = "_"+i
                            s.push(aa)
                        }
                        if (this.approveData.FileStatus != "_1"){
                            queryWrapper.in("FlowStep",s)
                        }
                        await this.caSignatureApi.deleteByFilter(queryWrapper)
                        await this.flowApi.returnTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, backlist[0].BackNode, this.getUserId(), this.getUserTrueName(), "1");
                        this.showPass = false;
                        this.success('审批通过');
                        let res: any = await this.flowApi.getNextNodeInfo(this.approveData.Id, backlist[0].BackNode)
                        if (res.data) {
                            this.sendWeChartMsgToAppoint(res.data,this.steps[0].ApproveUser, this.approveData.Title, this.approveData.Title)
                            this.sendWeComMsgToAppoint(res.data, this.steps[0].ApproveUser,this.approveData.Title, this.approveData.Title)
                        }
                        if (this.pageComponent) {
                            this.pageComponent!.closeModal();
                            if (backlist[0].BackNode == "_1") {
                                this.approveData.FileStatus = 1
                                this.approveData.FlowState = 3
                            } else {
                                this.approveData.FileStatus = backlist[0].BackNode
                            }
                            this.pageComponent!.return(false, this.approveData, data);
                        }
                        this.$nextTick(() => {
                            this.$emit('returnTask');
                        })
                        return;
                    } else {
                        let apiResult = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), this.isNull(data.nextUserIds) ? this.businessdataForm.nextUserIds : data.nextUserIds);
                        const result = this.parseApiResult(apiResult);
                        // let preNodeId = this.businessdataForm.nextStep   //选择跳转的节点id;
                        // this.approveData.FileStatus = preNodeId.split("_")[1]
                        // if (  this.approveData.isAudit == '1') await this.saveCaSign(this.approveData.BusinessKey)

                        this.getNextNodeInfo()
                        this.showPass = false;
                        this.success('审批通过');
                        if (this.pageComponent) {
                            this.pageComponent!.closeModal();
                            this.pageComponent!.pass(result, this.approveData);
                        }
                        this.$nextTick(() => {
                            this.$emit('passTask');
                        })
                        return;
                    }

                    //清除会签明细表数据；
                    if (res.data.length > 0) {
                        let ids = res.data.map(e => e.Id);
                        this.countersignRecordSheetApi.deleteByIds(ids.join());
                    }
                }
            } else {
                debugger
                if (this.actReFlow.FlowCode == "SealApply" ||this.actReFlow.FlowCode == "SealApplyNew" || this.actReFlow.FlowCode == "ContractManagementApply" || this.actReFlow.FlowCode == "WorkOverApplyLL" || this.actReFlow.FlowCode == "ReadknowledgeApply" || this.actReFlow.FlowCode == "QT-NoticeRectification"|| this.actReFlow.FlowCode == "DesignChange") {
                    let newStep = this.steps[this.steps.length - 1]
                    this.newStep = newStep
                    let nextUserIdList = []
                    if (!this.isNull(this.businessdataForm.nextUserIds)) {
                        let nextUserIds = this.businessdataForm.nextUserIds
                        nextUserIdList = nextUserIds.split(",")
                    }

                    if (newStep.PreNode == "_4" || newStep.PreNode == "_2"|| newStep.PreNode == "_12") {
                        let nextUserIds = this.businessdataForm.nextUserIds

                        let NumberReaders = nextUserIdList.length;
                        let apiResult = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), this.businessdataForm.nextUserIds, {loopNum: NumberReaders});
                        const result = this.parseApiResult(apiResult);
                        this.showPass = false;
                        this.success('审批通过');
                        if (this.pageComponent) {
                            this.pageComponent!.closeModal();
                            this.pageComponent!.pass(result, this.approveData);
                        }
                        this.$nextTick(() => {
                            this.$emit('passTask');
                        })
                        if (nextUserIdList.length >= 1) {
                            //拾取任务
                            await this.flowApi.claimTask(this.approveData.ActProcessInstanceId, nextUserIds)
                            this.sendWeComMsgToAppoint(nextUserIds, this.approveData.Title, this.approveData.Title)
                            this.sendWeChartMsgToAppoint(nextUserIds,"" ,this.approveData.Title, this.approveData.Title)
                        }
                        return;

                    } else {
                        await this.getNextNodeInfo()
                        let apiResult = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), this.businessdataForm.nextUserIds);
                        const result = this.parseApiResult(apiResult);
                        this.showPass = false;
                        this.success('审批通过');
                        if (this.pageComponent) {
                            this.pageComponent!.closeModal();
                            this.pageComponent!.pass(result, this.approveData);
                        }
                        this.$nextTick(() => {
                            this.$emit('passTask');
                        })
                        return;
                    }
                } else {

                    let apiResult = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), this.isNull(data.nextUserIds) ? this.businessdataForm.nextUserIds : data.nextUserIds);
                    const result = this.parseApiResult(apiResult);
                    // if (  this.approveData.isAudit ==  '1' ) await this.saveCaSign(this.approveData.BusinessKey)
                    this.showPass = false;
                    await this.getNextNodeInfo()
                    this.success('审批通过');
                    if (this.pageComponent) {
                        this.pageComponent!.closeModal();
                        this.pageComponent!.pass(result, this.approveData);
                    }
                    this.$nextTick(() => {
                        this.$emit('passTask');
                    })
                    return;
                }

            }

        } else if (this.actReFlow.FlowCode == "WithoutApprove") {
            let list = this.businessdataList
            let apiResult = await this.archiveApproveItemApi.getEntitiesDynamic(this.getQueryWrapper().eq("ApprovrId", this.actReFlow.Id).eq("ApproveUserId", this.$globalData_Plms.localUser.id).eq("StepStatus", 1).eq("PreNode", this.actReFlow.PreNode))
            const result = this.parseApiResult(apiResult);
            await this.archiveApproveItemApi.save({
                Id: result[0].Id,
                StepStatus: 2,
                ApproveMsg: data.msg,
                ApproveTime: new Date()
            })
            await this.archiveApproveItemApi.saves(this.businessdataList)
            await this.archiveApproveApi.update(this.actReFlow)
            this.showPass = false;
            this.success('审批通过');
            if(list.length>0){
                let ids = list.map(e => e.ApproveUserId);
                this.sendWeComMsgToAppoint(ids.join(','), this.approveData.Title, this.approveData.Title)
                this.sendWeChartMsgToAppoint(ids.join(','),"" ,this.approveData.Title, this.approveData.Title)
            }
            if (this.actReFlow.PreNode == "_3") {
                let apiResult2 = await this.archiveApproveItemApi.getEntitiesDynamic(this.getQueryWrapper().eq("ApprovrId", this.actReFlow.Id).eq("PreNode", "_3"))
                let res = this.parseApiResult(apiResult2).filter(e => e.StepStatus != 2)

                if (res.length == 0) {
                    //
                    this.sendWeComMsgToAppoint(261, this.approveData.Title, this.approveData.Title)
                }
            }
            if (this.pageComponent) {
                this.pageComponent!.closeModal();
                this.pageComponent!.pass(result, this.approveData);
            }
            this.$nextTick(() => {
                this.$emit('passTask');
            })
        } else {

            await this.getNextNodeInfo()
            let apiResult = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), this.businessdataForm.nextUserIds ? this.businessdataForm.nextUserIds : '');
            const result = this.parseApiResult(apiResult);
            // if (  this.approveData.isAudit == '1') await this.saveCaSign(this.approveData.BusinessKey)
            this.showPass = false;
            this.success('审批通过');
            if (this.pageComponent) {
                this.pageComponent!.closeModal();
                this.pageComponent!.pass(result, this.approveData);
            }
            this.$nextTick(() => {
                this.$emit('passTask');
            })
        }


        this.btnLoading = false;
    }

    //会签最后一个节点
    isEnd(flag) {
        this.isEndFlag = flag
    }

    /**
     * 保存签字
     */
    async saveCaSign(caResult,Type:any =1) {
        // const caResult = await this.caSign.DoSeal(1, Code) as any;
        // if (caResult==-1){
        //     this.error("CA密钥错误，请重新输入！")
        //     return
        // }
        // if (caResult==-2){
        //     return
        // }
        if (!this.isNull(caResult)) {
            let IsSign = 0;
            if (!this.isNull(this.approveData.nrOfActiveInstances)&&this.approveData.nrOfActiveInstances!=0){
                IsSign = 1
            }
              let imgHg = await this.caSign.VerifySealWithResult(this.approveData.BusinessKey,caResult)
            let obj = {
                RoadId: this.$globalData_Plms.roadInfo.id,
                ProjectId: this.getProjectDataId(),
                UserId: this.getUserId(),
                UserName: this.getUserTrueName(),
                CACode: this.approveData.BusinessKey,
                CASignInfo: caResult,
                // CreateTime: this.getCurrentDate(),
                CreateTime: this.flowTime,
                SignName: this.approveData.ActName,
                FlowStep:this.FlowStep,
                IsSign:IsSign,
                FlowOpinion:this.FlowOpinion,
                SealImg:"",
                Type:Type
            }


            obj.SealImg = imgHg.sealImg
            await this.caSignatureApi.save(obj);
        } else {
            this.error(`签字失败`);
            return;
        }
    }

    async saveApproveInfo(){
        let IsSign = 0;
        if (!this.isNull(this.approveData.nrOfActiveInstances)&&this.approveData.nrOfActiveInstances!=0){
            IsSign = 1
        }
        let obj = {
            Id: 0,
            RoadId: 101,
            ApproveUserId: this.getUserId(),
            ApproveUser: this.getUserTrueName(),
            CACode: this.approveData.BusinessKey,
            // ApproveTime: this.getCurrentDate(),
            ApproveTime: this.flowTime,
            StepName: this.approveData.ActName,
            PreNode:this.FlowStep,
            IsSign:IsSign,
            // ApproveMsg:this.FlowOpinion
        }
        let res = await this.dataApproveInfoApi.getEntities(this.getQueryWrapper().eq("CACode", this.approveData.BusinessKey)
            .eq("PreNode", this.FlowStep).eq('ApproveUserId', this.getUserId()));
        if(res.code == 200 && res.data.length==0){
            await this.dataApproveInfoApi.save(obj)
        }

    }


    /**
     * 流程跳转
     */
    async JumpTask() {
        const data = this.ref("approvePassRef").getData();
        //节点==2，4 传1

        let res = await this.flowApi.passTask(this.approveData.ActProcessInstanceId, data.msg, this.approveData.Id, this.getUserId(), this.getUserTrueName(), (this.newStep.PreNode == "_2" || this.newStep.PreNode == "_4" || this.newStep.PreNode == "_5") ? "1" : "", {loopNum: 1});
        if (res.code == 200) {
            let preNodeId = this.businessdataForm.nextStep   //选择跳转的节点id;
            let apiResult = await this.flowApi.JumpTask(this.approveData.ActProcessInstanceId, preNodeId, {HandleUsers: data.nextUserIds});
            // const result = this.parseApiResult(apiResult);
            this.approveData.FileStatus = preNodeId.split(

                "_")[1]
            // if (  this.approveData.isAudit == '1') await this.saveCaSign(this.approveData.BusinessKey)
            this.showPass = false;
            this.success('审批通过');
            if (this.pageComponent) {
                this.pageComponent!.closeModal();
                this.pageComponent!.pass(apiResult.data, this.approveData);
            }
            this.$nextTick(() => {
                this.$emit('passTask');
            })
        }

    }

    /**
     * 流程跳转(多节点)
     */
    async JumpMultipleNodes() {
        const data = this.ref("approvePassRef").getData();
        let nextUserIds = this.businessdataForm.nextUserIds
        let nextUserIdList = nextUserIds.split(",")
        let NumberReaders = nextUserIdList.length;
        let preNodeId = this.businessdataForm.nextStep
        let params = {loopNum: NumberReaders}
        params['users' + preNodeId] = nextUserIds
        let apiResult = await this.flowApi.JumpMultipleNodes(this.approveData.ActProcessInstanceId, this.approveData.Id, preNodeId, data.msg, this.getUserId(), this.getUserTrueName(), nextUserIds, params)
        // if (  this.approveData.isAudit =='1') await this.saveCaSign(this.approveData.BusinessKey)
        this.showPass = false;
        this.success('审批通过');
        if (this.pageComponent) {
            this.pageComponent!.closeModal();
            this.pageComponent!.pass(apiResult.data, this.approveData);
        }
        if (nextUserIdList.length >= 1) {
            //拾取任务
            await this.flowApi.claimTask(this.approveData.ActProcessInstanceId, nextUserIds)
            this.sendWeComMsgToAppoint(nextUserIds, this.approveData.Title, this.approveData.Title)
            this.sendWeChartMsgToAppoint(nextUserIds,"" ,this.approveData.Title, this.approveData.Title)
        }
        this.$nextTick(() => {
            this.$emit('passTask');
        })

    }

    async getNextNodeInfo() {
        const flowCodeArray = ['QT-FinanceReport','QT_WorkerSalaryApproval','QT-DFFinanceReport','QT-AQFinanceReport']
        //1、首先判断是否是跳步骤
        if (!this.isNull(this.businessdataForm.nextStep)) {
            //判断是否是会签节点
            if (this.newStep.PreNode == "_5" || this.newStep.PreNode == "_3") {
                let nextUserIds = this.businessdataForm.nextUserIds;
                this.sendWeChartMsgToAppoint(nextUserIds,this.steps[0].ApproveUser, this.approveData.Title, this.approveData.Title)
                this.sendWeComMsgToAppoint(nextUserIds, this.approveData.Title, this.approveData.Title)
                // if (this.approveData.FlowCode=='QT-FinanceReport'||this.approveData.FlowCode=='QT_WorkerSalaryApproval'){
                if (flowCodeArray.includes(this.approveData.FlowCode)){
                    this.sendMobileMsgToAppoint(nextUserIds,this.approveData.Title,"",'')
                }
            } else {
                let res: any = await this.flowApi.getNextNodeInfo(this.approveData.Id, this.businessdataForm.nextStep)
                if (res.data) {
                    this.sendWeChartMsgToAppoint(res.data, this.steps[0].ApproveUser,this.approveData.Title, this.approveData.Title)
                    this.sendWeComMsgToAppoint(res.data, this.approveData.Title, this.approveData.Title)
                    // if (this.approveData.FlowCode=='QT-FinanceReport'||this.approveData.FlowCode=='QT_WorkerSalaryApproval'){
                    if (flowCodeArray.includes(this.approveData.FlowCode)){
                        this.sendMobileMsgToAppoint(res.data,this.approveData.Title,"",'')
                    }
                }
            }

        }
        let res: any = await this.flowApi.getNextNodeInfo(this.approveData.Id)
        if (res.type == "3") {
            //自选人推送消息
            this.sendWeChartMsgToAppoint(this.businessdataForm.nextUserIds,"", this.approveData.Title, this.approveData.Title)
            this.sendWeComMsgToAppoint(this.businessdataForm.nextUserIds, "", this.approveData.Title)
            // if (this.approveData.FlowCode=='QT-FinanceReport'||this.approveData.FlowCode=='QT_WorkerSalaryApproval'){
            if (flowCodeArray.includes(this.approveData.FlowCode)){
                this.sendMobileMsgToAppoint(this.businessdataForm.nextUserIds,this.approveData.Title,"",'')
            }
        } else {
            this.sendWeChartMsgToAppoint(this.result,this.steps[0].ApproveUser, this.approveData.Title, this.approveData.Title)
            this.sendWeComMsgToAppoint(this.result, this.approveData.Title, this.approveData.Title)
            // if (this.approveData.FlowCode=='QT-FinanceReport'||this.approveData.FlowCode=='QT_WorkerSalaryApproval'){
            if (flowCodeArray.includes(this.approveData.FlowCode)){
                this.sendMobileMsgToAppoint(this.result,this.approveData.Title,"",'')
            }
        }
    }


    //#endregion 方法定义区
}
